export default __webpack_public_path__ + "static/media/clock.87ef448c.svg";